import React from 'react'
import styled from 'styled-components'

import { useDispatch } from 'react-redux'

import {
  setShowMembershipModal,
  setShowPurchaseCoins
} from '../../redux/designerReducers/designerReducer'
import { logEvent } from '../../utils/firebase'

import profileBG from '../../assets/images/membership-banner/profile.png'
import wideProfileBG from '../../assets/images/membership-banner/profile-wide.png'
import postBG from '../../assets/images/membership-banner/post.png'
import widePostBG from '../../assets/images/membership-banner/post-wide.png'
import icon from '../../assets/images/membership-banner/icon.png'

const Container = styled.button`
  border-radius: ${({ variant }) => (variant === 'profile' ? '10px' : '0')};
  height: ${({ variant }) => (variant === 'profile' ? '86px' : '73px')};
  width: 100%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-image: url(${({ variant }) =>
    variant === 'profile' ? profileBG : widePostBG});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0;

  & img {
    width: 50px;
    height: auto;
    object-fit: contain;
  }

  @media only screen and (max-width: 1000px) {
    height: 75px;
    background-image: url(${({ variant }) =>
      variant === 'profile' ? wideProfileBG : widePostBG});
  }

  @media only screen and and (max-width: 820px) {
    background-image: url(${({ variant }) =>
      variant === 'profile' ? profileBG : postBG});
  }
`

const Title = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: #fff;
  max-width: ${({ variant }) => (variant === 'profile' ? '150px' : 'none')};

  @media only screen and (max-width: 1000px) and (min-width: 820px) {
    max-width: none;
  }

  @media only screen and (max-width: 820px) {
    max-width: ${({ variant }) => (variant === 'profile' ? '100px' : '130px')};
    font-size: ${({ variant }) => (variant === 'profile' ? '18px' : '16px')};
  }
`

const Button = styled.div`
  height: 36px;
  padding: 0 23px;
  border-radius: 37px;
  color: #fff;
  background: #ff5e6d;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  @media only screen and (max-width: 820px) {
    height: ${({ variant }) => (variant === 'profile' ? '36px' : '30px')};
    font-size: ${({ variant }) => (variant === 'profile' ? '16px' : '11px')};
    padding: 0 ${({ variant }) => (variant === 'profile' ? '23px' : '10px')};
  }
`

export const MembershipBanner = ({ variant }) => {
  const dispatch = useDispatch()

  const handleUpgrade = () => {
    logEvent('show_purchase_coin', {
      content_type: 'purchase'
    })
    dispatch(setShowMembershipModal(true))
  }

  return (
    <Container variant={variant} onClick={handleUpgrade}>
      <img src={icon} alt="membership" />
      <Title variant={variant}>
        {variant === 'profile' ? 'Free Designing?' : 'Unlock All Premium Items'}
      </Title>
      <Button variant={variant}>
        {variant === 'profile' ? 'Upgrade' : 'Become a Member'}
      </Button>
    </Container>
  )
}
